import { observer } from 'mobx-react-lite'
import { css, styled } from '../../../lib/stitches'
import { useTreeState } from '../../../stores/Root'
import { IconButton } from '../../core/Components'
import { RedoIcon, UndoIcon } from '../../core/icons'
import withTooltip from '../../core/withTooltip'
import { segmentStudioButton } from '../StudioUtils'

const StyledUndoRedo = styled('div', {
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center'
})

const UNDO_TITLE = 'Undo (ctrl + z)'
const REDO_TITLE = 'Redo (ctrl + shift + z)'

const iconStyles = css({ width: '17px', height: '17px' })

const IconButtonWithTooltip = withTooltip(IconButton)

const UndoRedo = observer(() => {
  const {
    studio: { canRedo, canUndo, redo, undo }
  } = useTreeState()
  return (
    <StyledUndoRedo>
      <IconButtonWithTooltip
        disabled={!canUndo}
        onClick={() => {
          segmentStudioButton('Undo', 'studio header')
          undo()
        }}
        tooltipText={UNDO_TITLE}
      >
        <UndoIcon className={iconStyles()} />
      </IconButtonWithTooltip>
      <IconButtonWithTooltip
        disabled={!canRedo}
        onClick={() => {
          segmentStudioButton('Redo', 'studio header')
          redo()
        }}
        tooltipText={REDO_TITLE}
      >
        <RedoIcon className={iconStyles()} />
      </IconButtonWithTooltip>
    </StyledUndoRedo>
  )
})

export default UndoRedo
